import React from 'react';
import Styles from '../../assets/css/components/inventory/companyDetailsModal.module.scss';
import { IoMdClose } from 'react-icons/io';
import { FiMail, FiPhone, FiMapPin, FiUser } from 'react-icons/fi';
import { MdBusiness, MdEmail } from 'react-icons/md';

const CompanyDetailsModal = ({ company, onClose }) => {
    if (!company) return null;

    return (
        <div className={`${Styles.modalOverlay}`}>
            <div className={`${Styles.modalContainer}`}>
                <div className={`${Styles.modalHeader}`}>
                    <div className={`${Styles.headerContent}`}>
                        <MdBusiness className={`${Styles.companyIcon}`} />
                        <h2>Company Details</h2>
                    </div>
                    <button className={`${Styles.closeButton}`} onClick={onClose}>
                        <IoMdClose />
                    </button>
                </div>

                <div className={`${Styles.modalBody}`}>
                    <div className={`${Styles.companyInfoSection}`}>
                        <div className={`${Styles.sectionHeader}`}>
                            <h3>Company Information</h3>
                        </div>

                        <div className={`${Styles.detailsGrid}`}>
                            <div className={`${Styles.detailItem}`}>
                                <div className={`${Styles.detailLabel}`}>
                                    <MdBusiness className={`${Styles.icon}`} />
                                    <span>Company Name</span>
                                </div>
                                <div className={`${Styles.detailValue}`}>
                                    {company.company_name || 'N/A'}
                                </div>
                            </div>

                            <div className={`${Styles.detailItem}`}>
                                <div className={`${Styles.detailLabel}`}>
                                    <MdBusiness className={`${Styles.icon}`} />
                                    <span>UEN Number</span>
                                </div>
                                <div className={`${Styles.detailValue}`}>
                                    {company.company_uen_number || 'N/A'}
                                </div>
                            </div>

                            <div className={`${Styles.detailItem}`}>
                                <div className={`${Styles.detailLabel}`}>
                                    <FiMail className={`${Styles.icon}`} />
                                    <span>Company Email</span>
                                </div>
                                <div className={`${Styles.detailValue}`}>
                                    <a href={`mailto:${company.email}`} className={`${Styles.emailLink}`}>
                                        {company.email || 'N/A'}
                                    </a>
                                </div>
                            </div>

                            <div className={`${Styles.detailItem}`}>
                                <div className={`${Styles.detailLabel}`}>
                                    <FiPhone className={`${Styles.icon}`} />
                                    <span>Contact Number</span>
                                </div>
                                <div className={`${Styles.detailValue}`}>
                                    <a href={`tel:${company.contact_number}`} className={`${Styles.phoneLink}`}>
                                        {company.contact_number || 'N/A'}
                                    </a>
                                </div>
                            </div>

                            <div className={`${Styles.detailItem} ${Styles.fullWidth}`}>
                                <div className={`${Styles.detailLabel}`}>
                                    <FiMapPin className={`${Styles.icon}`} />
                                    <span>Address</span>
                                </div>
                                <div className={`${Styles.detailValue}`}>
                                    {company.address || 'N/A'}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${Styles.contactPersonSection}`}>
                        <div className={`${Styles.sectionHeader}`}>
                            <h3>Contact Person Details</h3>
                        </div>

                        <div className={`${Styles.detailsGrid}`}>
                            <div className={`${Styles.detailItem}`}>
                                <div className={`${Styles.detailLabel}`}>
                                    <FiUser className={`${Styles.icon}`} />
                                    <span>Contact Person</span>
                                </div>
                                <div className={`${Styles.detailValue}`}>
                                    {company.main_contact_person_name || 'N/A'}
                                </div>
                            </div>

                            <div className={`${Styles.detailItem}`}>
                                <div className={`${Styles.detailLabel}`}>
                                    <MdEmail className={`${Styles.icon}`} />
                                    <span>Contact Email</span>
                                </div>
                                <div className={`${Styles.detailValue}`}>
                                    {company.main_contact_person_email ? (
                                        <a href={`mailto:${company.main_contact_person_email}`} className={`${Styles.emailLink}`}>
                                            {company.main_contact_person_email}
                                        </a>
                                    ) : 'N/A'}
                                </div>
                            </div>

                            <div className={`${Styles.detailItem}`}>
                                <div className={`${Styles.detailLabel}`}>
                                    <FiPhone className={`${Styles.icon}`} />
                                    <span>Contact Phone</span>
                                </div>
                                <div className={`${Styles.detailValue}`}>
                                    {company.main_contact_person_phone_number ? (
                                        <a href={`tel:${company.main_contact_person_phone_number}`} className={`${Styles.phoneLink}`}>
                                            {company.main_contact_person_phone_number}
                                        </a>
                                    ) : 'N/A'}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* {company.remark && (
                        <div className={`${Styles.remarksSection}`}>
                            <div className={`${Styles.sectionHeader}`}>
                                <h3>Remarks</h3>
                            </div>
                            <div className={`${Styles.remarkContent}`}>
                                {company.remark}
                            </div>
                        </div>
                    )} */}
                </div>

                {/* <div className={`${Styles.modalFooter}`}>
                    <button className={`${Styles.closeBtn}`} onClick={onClose}>
                        Close
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default CompanyDetailsModal;